import { useMeasurementsOverview } from "@api/generated/measurements/measurements";

export const KEEP = { staleTime: 10 * 60_000, gcTime: Number.POSITIVE_INFINITY }; // also what the phone walks with offline

/** The trials of the season that have register plots, the chosen one and its site (the first one unless chosen). */
export function useTrial(ev: number | undefined, kis: string | undefined, site: string | undefined) {
  const trials = (useMeasurementsOverview(ev ?? 0, { query: { enabled: !!ev, ...KEEP } }).data ?? []).filter((o) => o.register_plots > 0);
  const trial = trials.find((o) => o.kis === kis);
  return { trials, trial, th: site ?? trial?.sites[0] };
}
